import { createApiPath } from '@/shared/api/endpoints';
import { apiClient } from '@/shared/api/http-client';

export type SocialProvider = 'kakao' | 'naver' | 'google' | 'apple';

/** GET /web/auth/me — 앱 /api/v1/auth/me와 같은 필드. 웹에서 쓰는 필드만 둔다 */
export interface UserDetail {
  nickname: string;
  email: string;
  status?: string;
  /** 영업 승인 상태 — 처방 등록은 SETTLEMENT_POSSIBLE일 때만 가능 (M-07 분기표) */
  salesApprovalStatus?:
    'TRANSACTION_IMPOSSIBLE' | 'TRANSACTION_POSSIBLE' | 'SETTLEMENT_POSSIBLE';
}

/** 웹 로그인 응답에는 토큰만 온다. 사용자 정보는 me로 따로 받는다 */
export interface AuthTokens {
  token: string;
  refreshToken: string;
}

/**
 * SNS 로그인 요청 — 서버는 제공자 토큰을 검증만 한다 (docs/api/auth.md)
 * kakao · google · apple: idToken + nonce(원문) / naver: accessToken
 * 길이 상한: idToken 16384, accessToken 4096, nonce 512
 */
export type SocialLoginRequest =
  { idToken: string; nonce: string } | { accessToken: string };

export const authApi = {
  /** 실패: 401 LOGIN_FAILED (없는 이메일·틀린 비밀번호·탈퇴 구분 없음), 429 LOGIN_ATTEMPTS_EXCEEDED */
  login: async (email: string, password: string) => {
    const { data } = await apiClient.post<AuthTokens>(
      createApiPath.auth.login(),
      { email, password },
    );
    return data;
  },
  /**
   * 실패: 401 SOCIAL_TOKEN_INVALID, 403 WEB_SIGNUP_NOT_SUPPORTED(연결 이력 없음) · ACCOUNT_INACTIVE,
   * 400 INVALID_PARAMETER · SOCIAL_PROVIDER_NOT_SUPPORTED, 502 SOCIAL_PROVIDER_UNAVAILABLE
   */
  socialLogin: async (provider: SocialProvider, body: SocialLoginRequest) => {
    const { data } = await apiClient.post<AuthTokens & { provider: string }>(
      createApiPath.auth.socialLogin(provider),
      body,
    );
    return data;
  },
  me: async () => {
    const { data } = await apiClient.get<UserDetail>(createApiPath.auth.me());
    return data;
  },
};
